/* Preview navigation is isolated in theme settings; no product assignment changes. */
(() => {
  const body = document.body;
  const selectedUrl = body.dataset.pwClassicUrl;
  const previewLinks = body.dataset.pwClassicPreview === 'true';
  const classic = selectedUrl ? new URL(selectedUrl, location.origin) : null;
  const routeLinks = () => {
    if (!classic || !previewLinks) return;
    document.querySelectorAll('a[href]').forEach((link) => {
      try {
        const target = new URL(link.getAttribute('href'), location.origin);
        if (target.origin !== location.origin || target.pathname !== classic.pathname || target.searchParams.get('view') === 'peitway-classic') return;
        target.searchParams.set('view', 'peitway-classic');
        link.setAttribute('href', target.pathname + target.search + target.hash);
      } catch (_) { /* Non-HTTP links do not participate in product preview routing. */ }
    });
  };
  const defaultWidgets = '#seedgrow-whatsapp-chat, .wa__btn_popup, .wa__popup_chat_box, #vista-whatsapp-chat';
  const widgets = new Set();
  let state = { visible: false, modal: false };
  let pending = false;
  const positionWidgets = () => {
    const modalOpen = Boolean(document.querySelector('cart-drawer.active, cart-notification.active, product-modal[open], modal-dialog[open], .menu-drawer-container[open], details-modal details[open], dialog[open]'));
    const cookieOpen = [...document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs')].some((element) => {
      const style = getComputedStyle(element);
      return !element.hidden && style.display !== 'none' && style.visibility !== 'hidden' && element.getBoundingClientRect().height > 0;
    });
    widgets.forEach((widget) => {
      if (!widget.isConnected) { widgets.delete(widget); return; }
      widget.classList.toggle('pw-wa-lift', state.visible);
      widget.classList.toggle('pw-wa-hidden', state.modal || modalOpen || cookieOpen);
    });
  };
  const discover = () => {
    pending = false;
    routeLinks();
    let found;
    try { found = document.querySelectorAll(body.dataset.pwWhatsappSelector || defaultWidgets); }
    catch (_) { found = document.querySelectorAll(defaultWidgets); }
    found.forEach((element) => {
      // Never move inline WhatsApp app blocks. Only fixed floating controls.
      if (getComputedStyle(element).position === 'fixed') widgets.add(element);
    });
    positionWidgets();
  };
  new MutationObserver(() => {
    if (!pending) { pending = true; requestAnimationFrame(discover); }
  }).observe(body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'open', 'hidden'] });
  document.addEventListener('peitway:sticky', (event) => { state = event.detail; positionWidgets(); });
  discover();
})();
